import React, { PureComponent } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'

class ModalValidateProductsAdoptionMode extends PureComponent {
  render() {
    const { open, close, item } = this.props

    return (
      <Dialog open={open} className={'container-small-modal'}>
        <DialogTitle>Adoption Mode</DialogTitle>
        <DialogContent className={'size-small-modal'}>
          <span className={'text-description-adoption-mode'}>You have no {item} selected</span>
        </DialogContent>
        <DialogActions className="align-image-component-to-create-product">
          <Button onClick={close} className="button-blue-and-white">
            <span className="button-text">OK</span>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default ModalValidateProductsAdoptionMode



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/ModalValidateProductsAdoptionMode.js